<template>
  <div class="brand_img">
    <div class="card-top">
      <div class="img-box">
        <img
          :src="
            dataList.logoImageUrl +
            '?x-oss-process=style/style_detail_banner_img'
          "
          alt
        />
      </div>

      <div>
        <p class="van-ellipsis">
          <span>{{ dataList.branchName }}</span>
          <!-- <i class="outlet-icon">Outlet</i> -->
        </p>
        <b class="discount">{{ todayActivity }}</b>
      </div>

      <!-- <span
        @click="followClick"
        :class="followText == '已关注' ? 'nozhu' : 'zhu'"
        >{{ followText }}</span
      > -->
    </div>
    <van-cell title="店铺证照" value="" is-link @click="setBrandInfo" />
    <div class="card">
      <div class="title">店铺介绍</div>
      <div class="info" v-html="dataList.info"></div>
    </div>
    <!-- <van-button
      :icon="$theme.system_icon_avatar_attach"
      class="div-btn-a"
      @click="contactFun()"
      >联系{{ $theme.system_text_shoppers }}</van-button
    > -->
  </div>
</template>
<script>
import http from "@/utils/axios";
import utils from "@/utils/common";
export default {
  data() {
    return {
      imgs: [],
      followText: "关注",
      dataList: [],
      frightListVisible: false,
      todayActivity: "",
    };
  },
  created() {
    this.$loading.hide();
    this.getBrandIndex();
  },
  methods: {
    contactFun() {
      let that = this;
      var bid = this.$route.query.id
        ? parseFloat(this.$route.query.id)
        : parseFloat(this.$route.query.brandId);
      utils.contactBees(bid);
      that.$publicFunc.getJumpSingeOrTeam({
        statusParmes: {
          branchId: bid,
        },
        teamParmes: {
          branchId: bid,
        },
        callback: function (status, teamDetail) {
          utils.beeChatGioReport({
            gio: that.gioObj,
            business: {
              branchId: bid,
              key: "easemob",
              teamChatId:
                status.isTeamChat && teamDetail.teamChatId
                  ? teamDetail.teamChatId
                  : "",
            },
          });
        },
      });
    },
    funaddress(item, type) {
      if (item) {
        return JSON.parse(item)[type];
      }
    },
    followClick() {
      this.$minicode.show({
        pageCode: "5010301",
        pageQueryParam: this.$route.query,
        isShow: "为了您有更好的体验，请您下载APP 或打开小程序",
      });
      if (this.followText == "已关注") {
        this.$dialog
          .confirm({
            message: "是否取消关注",
            title: "提示",
          })
          .then((rps) => {
            this.isFollowFun(true);
          });
      } else {
        this.isFollowFun(false);
      }
    },
    isFollowFun(isfollow) {
      http({
        url: "shop/user/branch/follow/" + this.dataList.id,
        method: "put",
      }).then((rps) => {
        if (rps.code === 200) {
          if (isfollow) {
            this.$toast("取消关注");
            this.followText = "+ 关注";
          } else {
            this.$toast("关注成功");
            this.followText = "已关注";
          }
          this.getBrandIndex();
        } else {
          this.$toast(rps.message);
        }
      });
    },
    getBrandIndex() {
      let id = this.$route.query.id
        ? this.$route.query.id
        : this.$route.query.brandId;

      if (id) {
        http({
          url: "shop/user/branch/" + id,
          method: "get",
        }).then((rps) => {
          if (rps.code == 200) {
            this.dataList = rps.data;
            this.followText = rps.data.isFollow ? "已关注" : "+ 关注";
            this.$loading.hide();
            this.todayActivity = eval(
              "(" + rps.data.extended + ")"
            ).todayActivity;
          }
        });
      }
    },
    setBrandInfo() {
      let { extended, license } = this.dataList;
      let params = {
        extended: extended,
        license: license,
      };
      window.sessionStorage.setItem("extended", JSON.stringify(params));
      this.$router.push({ path: "/brandinfo" });
    },
  },
};
</script>
<style  scoped lang="less">
.brand_img {
  margin-bottom: 120px;
  background: #fff;
  .card {
    border-top: 20px solid #f7f7f7;
    padding: 30px;
    .van-cell {
      padding-left: 0;
      padding-right: 0;
      font-size: 24px;
    }
    .title {
      font-size: 26px;
      color: #333;
      padding: 20px 0;
    }
    .info {
      font-size: 24px;
      color: #999;
      line-height: 40px;
    }
    .min-title {
      font-size: 28px;
      text-align: center;
      color: #333;
      span {
        display: inline-block;
        padding: 0 10px;
        position: relative;
        &::after {
          content: "";
          width: 90px;
          height: 1px;
          background: #f0f0f0;
          position: absolute;
          top: 20px;
          right: 0;
        }
        &::before {
          content: "";
          width: 80px;
          height: 1px;
          background: #f0f0f0;
          position: absolute;
          top: 20px;
          left: 0;
        }
      }
    }
    .wrap {
      .margin {
        margin: 10px 10px 20px 10px;
        border-radius: 10px;
        border: 1px solid #f2f2f2;
      }
      .item-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #686868;
        box-sizing: border-box;
        .item-block {
          border: none;
          border-radius: 0.1rem;
          overflow: hidden;
          position: relative;
          margin: 0 0 10px 0;
          background-color: #fff;
          width: 100%;
          max-height: 400px;
          img {
            width: 100%;
          }
        }
        .card-content {
          padding: 0 20px;
          width: 100%;
          box-sizing: border-box;
          font-size: 28px;
        }
        .card-footer {
          min-height: 44px;
          width: 100%;
          box-sizing: border-box;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          padding: 10px 20px;
          .color {
            color: #e83636;
            font-size: 26px;
          }
          .color-cc {
            color: #ccc;
            font-size: 26px;
            text-decoration: line-through;
          }
        }
      }
    }
  }
  .card-top {
    border-bottom: 20px solid #f7f7f7;
    display: flex;
    align-items: flex-start;
    color: #333;
    padding: 50px 30px;
    .img-box {
      width: 120px;
      height: 120px;
      border: 1px solid #ccc;
      img {
        width: 100px;
        height: 66.67px;
        object-fit: cover;
        padding: 0 10px;
        margin-top: 25px;
      }
    }

    p.van-ellipsis {
      font-size: 32px;
      width: 368px;
      padding-left: 30px;
      padding-right: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333;
      display: flex;
      align-items: center;
      span {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: 368px;
        text-align: left;
      }
      .outlet-icon {
        font-style: normal;
        display: inline-block;
        width: 72px;
        height: 40px;
        border-radius: 10px;
        border: 1px solid #333333;
        font-size: 20px;
        padding: 0 5px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 40px;
        text-align: center;
        margin-left: 10px;
        margin-top: 10px;
      }
    }
    .discount {
      padding-left: 30px;
      width: 120px;
      height: 33px;
      font-size: 24px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 33px;
    }
    span {
      width: 140px;
      font-size: 24px;
      text-align: center;
      padding: 8px 0;
      border-radius: 24px;
      margin-top: 10px;
    }
    .zhu {
      background-color: var(--buttonColor);
      color: var(--textColor);
      margin-left: 24px;
    }
    .nozhu {
      background-color: #f2f2f2;
      color: #999999;
    }
  }
}
.div-btn-a {
  display: block;
  width: 100%;
  line-height: 130px;
  height: 130px;
  text-align: center;
  border-radius: 0;
  border-top: 40px solid #f7f7f7 !important;
  padding: 20px;
  border: none;
  color: #333 !important;
  background-size: 40px 40px;
}
</style>